<div class="text-center flex flex-col items-center leading-relaxed gap-8">
  <h2 class="text-center max-w-xl py-8">
    Inserisci i dati della carta regalo per verificare l'importo disponibile e la scadenza.
  </h2>

  <div class="card-base overflow-y-visible">

    <div class="flex flex-grow w-full md:align-middle md:items-center">

      <form [formGroup]="cardValidationForm" class="flex flex-col p-8 gap-8 w-full">
        <app-card-field [parentGroup]="cardValidationForm" fieldName="cardIdField" title="ID Carta" inputMode="text"
          pattern="\b[A-F0-9]{16}\b"></app-card-field>
        <app-card-field [parentGroup]="cardValidationForm" fieldName="pinField" title="PIN" inputMode="numeric"
          [largeSpacing]="true" pattern="\d*"></app-card-field>
        <p>
          L'ID Carta e il PIN sono visibili sulla carta.
          <br />
          Nelle carte Tascabili il PIN è visibile dopo aver grattato la parte argentata.
        </p>
      </form>
    </div>

    <div class="low-band"></div>
  </div>
</div>